import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import path from 'path';
import { connect } from 'react-redux'
import { bindActionCreators }  from 'redux';
import Spinner from '@atlaskit/spinner'
import CrossIcon from '@atlaskit/icon/glyph/cross';

import { RightSidePanel, FlexContainer, ContentWrapper } from '@atlaskit/right-side-panel';
import { getObject } from 'api/actions';

import {
  GET_OBJECT,
  GET_OBJECT_SUCCESS,
  GET_OBJECT_FAILURE,
} from 'constants/ActionTypes';

import PreviewFile from './filePreview';

import { formatter } from 'utils'

import './index.css'

function _renderLoading() {
  return (
    <div className='file-preview__container'>
      <Spinner size="large"/>
    </div>
  )
}

function _renderCancel(onClose) {
  return (
    <div onClick={onClose}>
      <CrossIcon />
    </div>
  )
}

function _renderPreview(object, url, onClose) {
  if (!object) return null;

  return (
    <div className='file-preview__container'>
      <PreviewFile object={object} url={url}/>
      <div className='file-preview__info'>
        <h4>{object.name}</h4>
        <div>
          <p>Last modified:{' '}</p>
          <p>{formatter.formatDate(object.date_modified)}</p>
        </div>
        <div>
          <p>Starred:{' '}</p>
          <p>{String(object.starred)}</p>
        </div>
        <div>
          <p>Mime:{' '}</p>
          <p>{object.mime || '-'}</p>
        </div>
        <div>
          <p>Size:{' '}</p>
          <p>{formatter.memorySizeFormatter(object.size)}</p>
        </div>
      </div>
    </div>
  )
}

function FilePreview(props) {
  const [ data, setData ] = useState({})
  const [showing, setShowing] = useState(false);

  const { loading } = props;

  const onClose = () => setShowing(false);

  useEffect(() => {
    const { getObject, object, selection, showPreview } = props;

    if (showPreview !== showing) {
      setShowing(showPreview)
    }

    if (showPreview) {
      if (!object) {
        if (data) {
          if (data.id !== selection) {
            getObject({ id: selection }, { appendDownloadUrl: true })
          }
        } else {
          getObject({ id: selection }, { appendDownloadUrl: true })
        }
      } else {
        
        if (!data) setData(object); 
        else {
          if (data.id !== object.id) setData(object);
          else if ( JSON.stringify(data) !== JSON.stringify(object)) setData(object)
        }
      }
    }
  })


  return (
    <ContentWrapper>
      <RightSidePanel
        isOpen={showing}
        attachPanelTo="home-container"
      >
        {loading ? _renderLoading() : _renderPreview(data, data.downloadUrl, onClose)}
      </RightSidePanel>
    </ContentWrapper>
  )
}

FilePreview.defaultProps = {
  selections: new Set([])
}

const mapStateToProps = state => {
  const selections = state.selections || new Set([]);
  const selection = [...selections][0];

  const showPreview = selections.size === 1;
  const id = state.id;

  const sameObject = selection === id;
  let object = {}

  if (state.entities && state.entities.objects && selection) {
    object = state.entities.objects[selection];
  }

  const newState = {
    selection,
    showPreview
  }

  if (showPreview && sameObject) {
    switch(state.type) {
      case GET_OBJECT:
        newState.loading = true;
        break;
      case GET_OBJECT_SUCCESS:
        newState.loading = false;
        newState.object = object;
        break;
      case GET_OBJECT_FAILURE:
        newState.loading = false;
        newState.failed = true;
        break;
    }
  }
  
  return newState
}


const dispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getObject,
    }, dispatch)
};

export default connect(mapStateToProps, dispatchToProps)(FilePreview);
